import { TrendingUp } from 'lucide-react';

export function BetPlaceholder() {
  return (
    <div className="mt-3 rounded-lg border border-dashed border-gray-300 bg-gray-50/50 p-2.5" data-testid="bet-placeholder">
      <div className="flex items-center gap-2 mb-1.5">
        <TrendingUp className="w-3.5 h-3.5 text-muted-foreground" />
        <span className="text-[10px] font-semibold text-muted-foreground uppercase tracking-wider">Match Status</span>
      </div>
      <div className="grid grid-cols-3 gap-1.5 text-center text-[10px]">
        <div className="bg-white rounded border px-1 py-1">
          <div className="text-muted-foreground">Front</div>
          <div className="font-bold">E</div>
        </div>
        <div className="bg-white rounded border px-1 py-1">
          <div className="text-muted-foreground">Back</div>
          <div className="font-bold">1 UP</div>
        </div>
        <div className="bg-white rounded border px-1 py-1">
          <div className="text-muted-foreground">Overall</div>
          <div className="font-bold">E</div>
        </div>
      </div>
    </div>
  );
}
